import { clsx } from 'clsx';

import type { ReactElement } from 'react';
import type { IconProps } from 'components/Icon';

import styles from './FeedbackBox.module.css';

import { Icon } from 'components/Icon';

type FeedbackLevel = 'success' | 'warning' | 'error';

const LEVEL_ICON_MAP: Record<FeedbackLevel, IconProps['name']> = {
  success: 'CheckCircle',
  warning: 'ExclamationCircle',
  error: 'ExclamationTriangleMini',
};

export interface FeedbackBoxProps {
  /** The id of the element. */
  id?: string;
  /** The feedback level, indicates what icon is used. */
  level: FeedbackLevel;
  /** The feedback value. */
  feedback: string | ReactElement;
}

/** Represents a component to show feedback. */
export const FeedbackBox = ({ id, level, feedback }: FeedbackBoxProps) => (
  <div
    className={clsx(styles['feedback-box'], {
      [styles['feedback-box__success']]: level === 'success',
      [styles['feedback-box__warning']]: level === 'warning',
      [styles['feedback-box__error']]: level === 'error',
    })}
    id={id}
  >
    <Icon name={LEVEL_ICON_MAP[level]} size={16} />
    {feedback}
  </div>
);
